import { ClientAppSettings, SentrySettings } from "../dtos/Tmd.dtos";



export interface ISentrySettings {
    dsn?: string;
    customer: string;
    environment: string;
    sendDefaultPii: boolean;
    enableMetrics: boolean;
    attachStacktrace: boolean;
    debug: boolean;
    application: string;
    release?: string;
    replaysSessionSampleRate: number;
    replaysOnErrorSampleRate: number;
    enableLogs: boolean;
    tracesSampleRate: number;
    enableReportABug: boolean;
}

export interface IAppSettings {
    buildMode: "Development" | "Test" | "Staging" | "Training" | "Production";
    reportServerUrl: string;
    reportFolder: string;
    googleAnalyticsId: string;
    group2Enabled: boolean;
    sentry: ISentrySettings
}

const clientAppSettings: ClientAppSettings | undefined = (window as any).APP_SETTINGS;

const getSentryAppSettingValue = <TData>(
    appSettingProperty: keyof SentrySettings | undefined
): TData | undefined => {   
    if (!appSettingProperty) {
        return undefined;
    }
    const value: TData | undefined = clientAppSettings?.sentry?.[appSettingProperty] as TData;
    if (value === undefined || value === null) {
        return undefined;
    }
    return value;
};
const getSentryString = (
    appSettingProperty: keyof SentrySettings | undefined
) => {
    const appSettingValue = getSentryAppSettingValue<string>(appSettingProperty);
    if (appSettingValue) {
        return appSettingValue;
    }
    return undefined;
};

const getSentryNumber = (
    appSettingProperty: keyof SentrySettings | undefined
) => {
    const appSettingValue = getSentryAppSettingValue<number>(appSettingProperty);
    if (appSettingValue !== null && appSettingValue !== undefined) {
        return appSettingValue;
    }
    return undefined;
};

const getSentryBoolean = (
    appSettingProperty: keyof SentrySettings | undefined
) => {
    const appSettingValue = getSentryAppSettingValue<boolean>(appSettingProperty);
    if (appSettingValue !== null && appSettingValue !== undefined) {
        return appSettingValue;
    }
    return undefined;
};

export const AppSettings: IAppSettings = {
    ...(window as any).env,
    sentry: {
        dsn: getSentryString('dsn'),
        debug: getSentryBoolean('debug') ?? false,
        enableMetrics: getSentryBoolean('enableMetrics') ?? false,
        sendDefaultPii: getSentryBoolean('sendDefaultPii') ?? false,
        attachStacktrace: getSentryBoolean('attachStacktrace') ?? false,
        customer: getSentryString('customer') ?? 'TROG',
        environment:  getSentryString('environment') ?? 'Development',
        application: getSentryString('application') ?? 'Tmd',
        release: process.env.REACT_APP_SENTRY_RELEASE,
        enableLogs: getSentryBoolean('enableLogs') ?? false,
        replaysOnErrorSampleRate: getSentryNumber('replaysOnErrorSampleRate') ?? 1.0,
        replaysSessionSampleRate: getSentryNumber('replaysSessionSampleRate') ?? 0.1,
        tracesSampleRate: getSentryNumber('tracesSampleRate') ?? 0.2,
        enableReportABug: getSentryBoolean('enableReportABug') ?? false
    }
}; // || { buildMode: "Development", reportServerUrl: "", reportFolder: "", googleAnalyticsId: ""}; 